import React, { useState, useEffect, useRef } from "react";
import Services from "../../utils/services";
import {
    imsLoader,
} from "../../assets";
import { useHistory, useLocation } from "react-router";
import { Modal } from "react-bootstrap";
import ErrorBoundary from "../../components/ErrorBoundary/ErrorBoundary";
import {
    LocationOrigin,
} from "../../utils/utilityServices";
import { Authentication } from "../../utils/authenticationUtilityServices";
import axios from "axios";
import PageItems from "../../components/Paginate/PageItems";
import Pagination from "../../components/Paginate/Pagination";
import PubMedAuthorDocumentCard from "../../components/PubMedSearch/PubMedAuthorDocumentCard";

let _locationOrigin = LocationOrigin;
//_locationOrigin = "https://predev-ims.jnj.com";
let _timeoutTime = (1000 * (300));


function PubMedSearchAuthor() {
    const [customWidth, setCustomWidth] = useState(window.innerWidth);
    const [customHeight, setCustomHeight] = useState(window.innerHeight);
    const [isLoaded, setIsLoaded] = useState(false);
    const [isProcessing, setIsProcessing] = useState(true);
    const [itemsPerPage, setItemsPerPage] = useState(25);
    const [currentPage, setCurrentPage] = useState(1);
    const [documentCount, setDocumentCount] = useState(0);
    const [response, setResponse] = useState([]);

    const [spinnerMessage, setSpinnerMessage] = useState("");
    const [authorFullName, setAuthorFullName] = useState("");
    const [error, setError] = useState("");
    const [userExists, setUserExists] = useState("");
    const [errorExpand, setErrorExpand] = useState(true);

    const useridRef = useRef("");

    const history = useHistory();
    const location = useLocation();
    useEffect(() => {
        const initializePage = async () => {
            try {
                document.title = 'iMedical Search';
                window.scrollTo(0, 0);
                useridRef.current = JSON.parse(localStorage.getItem('username')) || "";
                let _userExists = localStorage.getItem('userExists');
                setUserExists(_userExists);
                let service = new Services();
                if (useridRef.current) {
                    service.logService(`PubMed Results Author page successfully mounted for ${useridRef.current.toLowerCase()}`, 'info');
                }
                if (!_userExists) {
                    console.log('Access Denied');
                    history.push('/');
                }
            } catch (error) {
            }
        };
        initializePage();
    }, [history]);
    useEffect(() => {
        const updateDimensions = () => {
            setCustomWidth(window.innerWidth);
            setCustomHeight(window.innerHeight)
        }
        // Add event listener
        window.addEventListener('resize', updateDimensions);
        // Cleanup function: remove event listener when component unmounts
        return () => {
            let service = new Services();
            window.removeEventListener('resize', updateDimensions);
            if (useridRef.current) {
                service.logService(`PubMed Results Author page successfully unmounted for ${useridRef.current.toLowerCase()}`, 'info')
            }
        };
    }, []); // Empty dependency array ensures this effect runs only once on mount

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const authorName = queryParams.get("authorName");
        setAuthorFullName(authorName);
        runPubmedSearchAuthorFromQueryParams(authorName, 25, 1);
    }, [location.search])
    const runPubmedSearchAuthorFromQueryParams = (_authorName, _ItemsPerPage, _currentPage) => {
        try {
            setIsProcessing(true);
            setItemsPerPage(_ItemsPerPage)
            setCurrentPage(_currentPage)
            if (_authorName && _authorName.split(' ').length > 1) {
                let _authorNameSplit = _authorName.split(' ');
                let firstName = _authorNameSplit[_authorNameSplit.length - 1];
                let lastName = _authorNameSplit.filter((x, i) => i < (_authorNameSplit.length - 1)).join(' ');
                runPubmedSearchAuthor(firstName, lastName, _ItemsPerPage, _currentPage);
            }
            else if (_authorName && _authorName.split(' ').length === 1) {
                runPubmedSearchAuthor(_authorName, "", _ItemsPerPage, _currentPage);
            } else {
                setIsProcessing(false);
            }
        } catch (error) {
            setIsProcessing(false);
        }
    }

    const runPubmedSearchAuthor = async (firstname, lastname, _ItemsPerPage, _currentPage) => {
        try {
            var url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_PUBMED}search/author`;
            if (window.location.origin === "https://predev-ims.jnj.com") {
                url = `${window.location.origin}${process.env.REACT_APP_IMS_API_PUBMED}search/author`;
            }
            const _headers = {
                "Content-Type": "application/json",
            }
            if (await Authentication.isAccessTokenAvailable()) {
                const token = await Authentication.getAccessToken();
                _headers.Authorization = `Bearer ${token}`;
            }
            let config = {
                method: "POST",
                url: url,
                headers: _headers,
                timeout: _timeoutTime,
            };
            config.data = {
                firstname: firstname,
                lastname: lastname,
                from_:
                    _currentPage * _ItemsPerPage - _ItemsPerPage,
                size: parseInt(_ItemsPerPage),
            };
            axios(config)
                .then((response) => {
                    setDocumentCount(response.data.hits.total.value);
                    setResponse(response.data.hits.hits);
                    setIsLoaded(true);
                    setIsProcessing(false);
                })
                .catch((err) => {
                    setError(err);
                    console.log({ err })

                })
                .finally(() => {
                    setIsLoaded(true);
                    setIsProcessing(false);
                });
        } catch (error) {
            setError(error);
            setIsLoaded(true);
            setIsProcessing(false);
        }
    }

    const handleChangeSelectItems = async (items) => {
        try {
            let _ItemsPerPage = items, _currentPage = currentPage;
            await setItemsPerPage(items);
            let totalPages = Math.ceil(
                documentCount / items
            );
            if (totalPages < currentPage) {
                await setCurrentPage(totalPages);
                _currentPage = totalPages;
            }
            const queryParams = new URLSearchParams(location.search);
            const authorName = queryParams.get("authorName");
            runPubmedSearchAuthorFromQueryParams(authorName, _ItemsPerPage, _currentPage);

        } catch (error) {
            setError(error);

            //this.setState({ error: error, errorExpand: true });
        }
    };
    const handlePageChange = async (_currentPage) => {
        try {
            window.scrollTo({ behavior: "smooth", top: "0px" });
            await setCurrentPage(_currentPage);
            const queryParams = new URLSearchParams(location.search);
            const authorName = queryParams.get("authorName");
            runPubmedSearchAuthorFromQueryParams(authorName, itemsPerPage, _currentPage);

        } catch (error) {
            setError(error)
            // this.setState({ error: error, errorExpand: true });
        }
    };
    const createErrorHtml = () => {
        if (error.response) {
            let _JSON = error.response.data;
            let mailbody = "";
            if (_JSON) {
                mailbody = encodeURIComponent(JSON.stringify(_JSON));
            }
            return (
                <>
                    <p style={{ wordBreak: "break-all" }}>
                        <b>ERROR: </b>
                        {_JSON.ERROR}
                        <br />
                        <b>MESSAGE: </b>
                        {_JSON && _JSON.message ? <>
                            {_JSON.message}
                        </> :
                            <>
                                {(_JSON.detail && _JSON.detail.length > 0 && _JSON.detail[0].msg) ? <>{_JSON.detail[0].msg}</> : <>{_JSON.MESSAGE}</>}
                            </>}

                        <br />
                        {(_JSON && _JSON.stackTrace) && <>
                            <b>STACKTRACE: </b>
                            {_JSON.stackTrace}
                            <br />
                        </>}
                        {(_JSON.detail && _JSON.detail.length > 0 && _JSON.detail[0].type) && <>
                            <b>TYPE: </b>
                            {_JSON.detail[0].type}
                            <br />
                        </>}
                        <br />
                        <b> Please contact{" "}
                            <a
                                href={`mailto:imks.jnj.com?subject= iMS PubMed2.0 Query Error - ${_JSON["REQUEST-ID"]}&body=${mailbody}`}
                            >
                                iMedical Search Support Team
                            </a></b>

                    </p>
                </>
            );
        } else {
            return error.message;
        }
    };
    const resultListCount = (_itemsPerPage, _currentPage, _documentCount, _response) => {
        try {
            var endIndex, startIndex;
            startIndex = _currentPage * _itemsPerPage - _itemsPerPage;
            endIndex = _currentPage * _itemsPerPage;

            return (
                <div className={"results-count-wrapper pubmed-main-right-section-result-list-count box-white-main"}>
                    {_response.length > 0 && (
                        <div className="resultListCount-container">
                            {_documentCount > 0 && (
                                <span
                                    className="showingResultsCountContainer" /* style={{ display: "flex", width: "200px" }} */
                                >
                                    {endIndex <= _documentCount ? (
                                        <div className="results-number-show-wrapper">
                                            Showing {(startIndex + 1).toLocaleString("en-us")}-
                                            {endIndex.toLocaleString("en-us")} of{" "}
                                            {_documentCount.toLocaleString("en-us")}{" "}
                                            Results
                                        </div>
                                    ) : (
                                        <div className="results-number-show-wrapper">
                                            Showing {(startIndex + 1).toLocaleString("en-us")}-
                                            {_documentCount.toLocaleString("en-us")} of{" "}
                                            {_documentCount.toLocaleString("en-us")}{" "}
                                            Results
                                        </div>
                                    )}
                                </span>
                            )}
                            <span
                                style={{
                                    marginRight: "0.5%",
                                    display: "flex",
                                    width: "180px",
                                }}
                            >
                                <PageItems
                                    handleChangeSelectItems={handleChangeSelectItems}
                                    itemsPerPage={itemsPerPage}
                                    customWidth={customWidth}
                                />
                            </span>
                            {/* <div className="sort-by-wrapper">
                                <span className="sort-by-text">Sort By:</span>

                            </div> */}
                        </div>
                    )}
                </div>
            );

        } catch (error) {
            setError(error);
            // this.setState({ error: error, errorExpand: true });
        }
    };
    const resultList = (results, itemsPerPage, currentPage) => {

        try {
            const queryParams = new URLSearchParams(location.search);
            const authorName = queryParams.get("authorName");
            var startIndex;
            startIndex = currentPage * itemsPerPage - itemsPerPage;
            var count = startIndex;
            let displayedResults = [];

            return (<>
                {(() => {
                    if (results.length > 0) {
                        return (
                            <>
                                <div className="pubmed-main-right-section-result-list box-white-main">
                                    <div
                                        className="sticky top-16 z-2 overflow-hidden rounded-border-20 bg-white/95 backdrop-blur dark:bg-secondary-950/75"
                                        // ref={(el) => {
                                        //     this.scrollingTableHeader = el;
                                        // }}
                                        id="scrolling-table-header"
                                    ></div>
                                    <div
                                        className="overflow-x-auto pubmed-main-right-section-result-list-body pt-1"
                                    // onScroll={(e) => this.handleScroll(e)}
                                    >
                                        <div>
                                            {results.map((item, index) => {
                                                count++;
                                                return (
                                                    <>
                                                        <div
                                                            key={`result-id-${index}`}
                                                            id={`result-id-${index}`}
                                                            className="mx-1 mb-2 rounded-2xl border-2 border-secondary-100 pubmed-main-result-item-border"
                                                        >
                                                            <PubMedAuthorDocumentCard
                                                                item={item._source}
                                                                pageNumber={currentPage}
                                                                pageSize={itemsPerPage}
                                                                count={count}
                                                                appliedFilters={[]}
                                                                searchKeyword={""}
                                                                isChecked={
                                                                    false
                                                                }
                                                                customWidth={customWidth}
                                                                globalCollapseAll={false}
                                                                index={index}
                                                                selectedAuthorName={authorName}
                                                            />
                                                            {/* <div className="resultsDivFooter"></div> */}
                                                        </div>
                                                    </>
                                                );
                                            })}
                                        </div>
                                    </div>
                                    {localStorage.setItem(
                                        "displayedResults",
                                        JSON.stringify(displayedResults)
                                    )}
                                </div>
                            </>
                        );

                    } else {
                        localStorage.removeItem("displayedResults");
                        return (
                            <div className="results-no-search-content pubmed-results-no-search-content">
                                <span><b>No results were found.</b></span>
                            </div>
                        );
                    }
                })()}
            </>)

        } catch (error) {
            setError(error)
            // this.setState({ error: error, errorExpand: true });
        }


    };


    return (
        <div>
            <ErrorBoundary>
                {userExists ? (<div className="pubmed-main-innerWrapper">
                    <div className="pubmed-main-section-container">
                        {isLoaded ? (<>
                            <div className="pubmed-main-section">
                                <div className="pubmed-author-main-section">
                                    {response.length > 0 && (
                                        <>
                                            {error === "" && authorFullName && <> <div className={"pubmed-search-author-title results-count-wrapper pubmed-main-right-section-result-list-count box-white-main"}>
                                                Author: {authorFullName}
                                            </div>
                                            </>}
                                            {error === ""
                                                ? resultListCount(
                                                    itemsPerPage,
                                                    currentPage,
                                                    documentCount,
                                                    response
                                                )
                                                : ""}
                                            <br />
                                        </>
                                    )}
                                    {error === "" ? (
                                        resultList(
                                            response,
                                            itemsPerPage,
                                            currentPage
                                        )
                                    ) : (
                                        <>
                                            {(() => {
                                                let service = new Services();
                                                service.logService(
                                                    error.stack,
                                                    "error"
                                                );
                                            })()}

                                            <div style={{ margin: "2rem 2rem" }}>
                                                <h2>Sorry, something went wrong</h2>

                                                {errorExpand ? (
                                                    <p
                                                        style={{
                                                            backgroundColor: "#f8d4d4",
                                                            borderColor: "#f5a6a7",
                                                        }}
                                                    >
                                                        {createErrorHtml()}
                                                    </p>
                                                ) : (
                                                    ""
                                                )}

                                                <p
                                                    style={{
                                                        fontSize: "0.9rem",
                                                        marginTop: "30px",
                                                        cursor: "pointer",
                                                    }}
                                                    onClick={() => { setErrorExpand(!errorExpand) }}
                                                >
                                                    {errorExpand
                                                        ? `SHOW LESS`
                                                        : `SHOW DETAILS`}
                                                </p>
                                            </div>
                                        </>
                                    )}
                                    {response.length > 0 && error === "" ? (
                                        <Pagination
                                            metadata={documentCount}
                                            handlePageChange={handlePageChange}
                                            itemsPerPage={parseInt(
                                                itemsPerPage
                                            )}
                                            page={parseInt(currentPage)}
                                            customWidth={customWidth}
                                            customHeight={customHeight}
                                        />
                                    ) : (
                                        ""
                                    )}
                                </div>
                            </div>
                            {isProcessing && (
                                <Modal
                                    show={isProcessing}
                                    size="lg md sm xs"
                                    centered
                                    aria-labelledby="contained-modal-title-vcenter"
                                    dialogClassName="savePopUp"
                                    className="document-processing-newthread"
                                    backdropClassName="document-processing-newthread-backdrop"
                                    scrollable={true}
                                >
                                    <div style={{ padding: "0 5%" }}>
                                        <div
                                            style={{
                                                fontSize: "14px",
                                                textAlign: "center",
                                            }}
                                        >
                                            <Modal.Body>
                                                <img
                                                    src={imsLoader}
                                                    alt=""
                                                    width={100}
                                                    height={100}
                                                />
                                                <div
                                                    className="saveModal-heading"
                                                    style={{ color: "#0074B0" }}
                                                >
                                                    {spinnerMessage ? spinnerMessage : `Please wait...`}
                                                </div>
                                            </Modal.Body>
                                        </div>
                                    </div>
                                </Modal>
                            )}
                        </>) : (<div style={{ textAlign: "center", padding: "10%" }}>
                            <img
                                src={imsLoader}
                                alt="Loading Data"
                                style={{ width: "10%" }}
                            />
                            <div className="saveModal-heading">
                                <b>Please wait...</b>
                            </div>
                        </div>)}
                    </div>
                </div>) : (
                    <div style={{ textAlign: "center", padding: "10%" }}>
                        <img
                            src={imsLoader}
                            alt="Loading Data"
                            style={{ width: "20%" }}
                        />
                    </div>
                )
                }
            </ErrorBoundary >
        </div >
    )

}
export default PubMedSearchAuthor;